import type { ContextValues } from "@atoms/atom-types";
import { createContext, useContext } from "react";

const ExtraContext = createContext<ContextValues>({});
export const useExtraContext = () => useContext(ExtraContext);
export const ExtraContextProvider = ExtraContext.Provider;
